/* eslint-disable no-undef, camelcase, prefer-destructuring */ /**
 * Function generator to handle the response from the Google Maps API, calling resolve or reject callbacks
 * @function
 * @param {Function} resolve
 * @param {Function} reject
 * @returns {Function}
 */ var handleStatus = function(resolve, reject) {
    return function(results, status) {
        switch(status){
            case "OK":
                resolve(results);
                break;
            case "ZERO_RESULTS":
                resolve([]);
                break;
            default:
                reject(status);
        }
    };
};
/**
 * Geocode using Google Maps API and lat/lng coordinates
 * @function
 * @param {Number} lat
 * @param {Number} lng
 * @param {Number} numOfResult - number of results to return default is 1
 * @returns {Promise}
 */ export var geocodeCoordinates = function(lat, lng, numOfResult) {
    if (numOfResult === void 0) numOfResult = 1;
    return new Promise(function(resolve, reject) {
        try {
            if (typeof window === "undefined") {
                reject(new Error("window is undefined"));
                return;
            }
            if (!window.google) {
                reject(new Error("google Api is not loaded"));
                return;
            }
            var geocoder = new google.maps.Geocoder();
            var latLng = new google.maps.LatLng(lat, lng);
            geocoder.geocode({
                location: latLng
            }, handleStatus(resolve, reject));
        } catch (error) {
            reject(error);
        }
    }).then(function(results) {
        var _results;
        return ((_results = results) == null ? void 0 : _results.slice(0, numOfResult)) || [];
    });
};
/**
 * Geocode using Google Maps API and an address
 * @function
 * @param {String} address
 * @param {Number} numOfResult - number of results, default 1
 * @returns {Promise}
 */ export var geocodeAddress = function(address, numOfResult) {
    if (numOfResult === void 0) numOfResult = 1;
    return new Promise(function(resolve, reject) {
        try {
            if (typeof window === "undefined") {
                reject(new Error("window is undefined"));
                return;
            }
            if (!window.google) {
                reject(new Error("google Api is not loaded"));
                return;
            }
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                address: address
            }, handleStatus(resolve, reject)).catch(function(error) {
                return reject(error);
            });
        } catch (error) {
            reject(error);
        }
    }).then(function(results) {
        var _results;
        return ((_results = results) == null ? void 0 : _results.slice(0, numOfResult)) || [];
    });
};

//# sourceMappingURL=google-maps.js.map